import React, { memo } from 'react'
import { Link } from '@mui/material'

import { RouterLink } from '../../routes/components'

const TextLink = ({ label, to, ...restProps }) => {
  const params = to ? { to, component: RouterLink } : {}
  return (
    <Link
      color='primary'
      variant='subtitle2'
      fontWeight={500}
      {...restProps}
      {...params}
    >
      {label}
    </Link>
  )
}

export default memo(TextLink)
